/** Código de erro das rotas de gateways WhatsApp → frase para a tela. */
const DETALHES: Record<string, string> = {
  forbidden: 'Você não tem permissão para isso nesta organização.',
  teto_atingido: 'A organização já tem 3 gateways ativos.',
  nome_invalido: 'O nome precisa ter de 1 a 80 caracteres.',
  job_ativo: 'Há uma operação em andamento neste gateway. Espere ela terminar.',
  ja_removido: 'Este gateway já foi removido.',
  gateway_not_found: 'Gateway não encontrado nesta organização.',
  organization_not_found: 'Organização não encontrada.',
  gateway_nao_provisionado: 'O gateway ainda não terminou de subir.',
  ja_pareado: 'Este gateway já está pareado. Desparear antes de gerar outro QR.',
  gateway_fora_do_registro: 'O WhatsApi ainda não conhece este gateway. A reconciliação corrige em alguns minutos.',
  pareamento_indisponivel: 'O gateway não conseguiu gerar o QR agora.',
  desparear_indisponivel: 'O gateway não conseguiu desparear. Gateway criado com a imagem anterior à Fase 4 não tem essa função.',
  qr_atual_invalido: 'O QR na tela não é válido. Gere outro.',
  whatsapi_limite: 'Muitas chamadas ao WhatsApi agora. Tente de novo em um minuto.',
  whatsapi_indisponivel: 'O WhatsApi não respondeu.',
  whatsapi_sem_credencial: 'O ConsoleAI não conseguiu a credencial do WhatsApi.',
  ecs_indisponivel: 'O ECS recusou ou não respondeu o pedido.',
  servico_ausente: 'O serviço deste gateway não existe no ECS.',
  chave_nao_encontrada: 'Chave não encontrada nesta organização.',
  chave_nao_aponta_para_este_gateway: 'Esta chave não aponta para este gateway.',
  gateway_de_outra_organizacao: 'O WhatsApi diz que o gateway é de outra organização.',
  whatsapi_recusou: 'O WhatsApi recusou a mudança.',
  trilha_falhou_chave_ja_alterada: 'A chave foi alterada, mas o registro na trilha falhou. Confira o estado antes de repetir a ação.',
  trilha_falhou_chave_desfeita: 'O registro na trilha falhou e a chave foi desfeita. Nada mudou; tente de novo.',
  nome_de_chave_invalido: 'O nome da chave precisa ter de 1 a 64 caracteres (letras, números, espaço, ponto, hífen ou sublinhado), com ao menos uma letra ou número.',
  nome_de_chave_em_uso: 'Já existe uma chave com esse nome no WhatsApi. Escolha outro.',
  gateway_nao_atualizavel: 'Só se atualiza gateway pronto, ou cuja atualização anterior falhou.',
  nao_falhou: 'O gateway não está com o provisionamento falho; não há o que retomar.',
  falha_de_remocao: 'A falha foi ao remover. Use "Excluir de novo".',
  falha_de_atualizacao: 'A falha foi ao atualizar. Use "Atualizar agora".',
  trilha_falhou_servico_reiniciado: 'O gateway foi reiniciado, mas o registro na trilha falhou. Confira o estado antes de repetir a ação.',
  gateway_com_chaves: 'Há chaves de API apontando para este gateway. Desaponte ou exclua cada uma antes de excluir o gateway.',
  chave_em_uso_pelo_bot: 'Esta chave atende o bot do WhatsApp deste gateway; peça ao suporte para trocar a chave do bot antes de excluir.',
  // Conversas (spec 2026-11-02 conversas §5.7); `conversa_em_atendimento` leva o nome, abaixo.
  conversa_em_atendimento: 'Outra pessoa já está atendendo esta conversa.',
  conversa_nao_assumida: 'Assuma a conversa para responder.',
  conversa_nao_pausada: 'Esta conversa já está com o bot.',
  conversa_nao_encontrada: 'Conversa não encontrada neste gateway.',
  texto_invalido: 'A resposta precisa ter de 1 a 4.096 caracteres.',
  invalid_ref: 'Conversa inválida. Recarregue a lista.',
  indisponivel_nesta_versao: 'Indisponível nesta versão do WhatsApi.',
  trilha_falhou_conversa_ja_alterada: 'A conversa foi alterada, mas o registro na trilha falhou. Não repita a ação.',
}

/** Motivo do transbordo do bot (`bot/index.js` do WhatsApi) → frase para a tela. */
const MOTIVOS_DO_TRANSBORDO: Record<string, string> = {
  sem_trecho: 'Sem resposta na base',
  pedido_humano: 'Pediu um atendente',
  erro_llm: 'Falha do modelo',
  sentinela: 'Resposta barrada pela verificação',
}

export function motivoDoTransbordo(motivo: string): string {
  return MOTIVOS_DO_TRANSBORDO[motivo] ?? motivo
}

function campo(v: unknown, nome: string): unknown {
  return v != null && typeof v === 'object' && nome in v ? (v as Record<string, unknown>)[nome] : undefined
}

export function mensagemDeErro(e: unknown): string {
  const dados = campo(campo(e, 'response'), 'data')
  const detalhe = campo(dados, 'detail')
  // 409 da exclusão do gateway: os nomes das chaves que seguram a remoção vêm em `chaves`.
  const chaves = campo(dados, 'chaves')
  if (detalhe === 'gateway_com_chaves' && Array.isArray(chaves) && chaves.length > 0) {
    const nomes = chaves.map((n) => `"${String(n)}"`).join(', ')
    return chaves.length === 1
      ? `A chave ${nomes} ainda aponta para este gateway. Desaponte ou exclua essa chave antes de excluir o gateway.`
      : `As chaves ${nomes} ainda apontam para este gateway. Desaponte ou exclua cada uma antes de excluir o gateway.`
  }
  const atendente = campo(dados, 'atendente_nome')
  if (detalhe === 'conversa_em_atendimento' && typeof atendente === 'string' && atendente) {
    return `${atendente} já está atendendo esta conversa.`
  }
  if (typeof detalhe === 'string') return DETALHES[detalhe] ?? detalhe
  // Axios marca timeout com code ECONNABORTED; a mensagem crua ("timeout of 40000ms
  // exceeded") não é para o usuário — a espera dura até 40s (TIMEOUT_ESPERA_MS).
  const err = e as { code?: string; message?: string }
  if (err?.code === 'ECONNABORTED' || (typeof err?.message === 'string' && err.message.toLowerCase().includes('timeout'))) {
    return 'O WhatsApi demorou para responder. Gere o QR de novo.'
  }
  return (e as Error)?.message || 'Falha inesperada.'
}
